import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {PageResponse} from '../../../shared/commons/page-response';

export interface ActivityLogReportPageData {
  id: number;
  operatorType: number;
  operatorTypeText: string;
  statusCode: string;
  detail: string;
  created: string;
  createdBy: number;
  createdByName: string | null;
  viewId: number;
  ipAddress: string;
  keep: boolean;
  keepDetail: string | null;
  keepBy: number | null;
  keepByName: string | null;
  keepAt: string | null;
  countDay: number;
}

export interface ActivityLogReportKeepRequest {
  ids: number[];
  keepDetail: string;
}

@Injectable({providedIn: 'root'})
export class ActivityLogReportService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = '/api/activity-log-report';

  search(params: Record<string, string | number>): Observable<PageResponse<ActivityLogReportPageData>> {
    return this.http.get<PageResponse<ActivityLogReportPageData>>(this.baseUrl, {params: params as any});
  }

  /** เก็บรักษาข้อมูลไว้ สำหรับรายการที่เลือก */
  keep(request: ActivityLogReportKeepRequest): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/keep`, request);
  }

  /** ยกเลิกการเก็บรักษาข้อมูล */
  cancelKeep(id: number): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${id}/cancel-keep`, {});
  }
}
